import {createSlice} from '@reduxjs/toolkit';

export const globalsSlice = createSlice({
    name: 'globals',
    initialState: {
        variables: {
            scrollCount: 0,
            scrollPositionEyonix: 0,
            smartFiltersSettings: null,
        },
        agyleHeaderContext: null,
        agyleHeaderLoading: false,
        snackbar: {
            type: null,
            message: undefined,
            action: [],
        },
        blockContext: false,
        openAlarms: false,
        openDischargeTimestampInfoForm: false,
        tempPiw: null,
        searchOnlyNumbers: false,
    },
    reducers: {
        setGlobalVariable: (state, variable) => {
            // FIXME: that may need to be somehow changed ...
            if (variable.payload.name === 'toolbarViewer1') {
                for (let c = 0; c < 10; c++) {
                    const nameV = 'toolbarViewer' + (10 + c);
                    state.variables[nameV] = variable.payload.value;
                }
            }
            if (variable.payload.name === 'toolbarViewer2') {
                for (let c = 0; c < 10; c++) {
                    const nameV = 'toolbarViewer' + (20 + c);
                    state.variables[nameV] = variable.payload.value;
                }
            }
            if (variable.payload.name === 'toolbarViewer3') {
                for (let c = 0; c < 10; c++) {
                    const nameV = 'toolbarViewer' + (30 + c);
                    state.variables[nameV] = variable.payload.value;
                }
            }
            if (variable.payload.name === 'toolbarViewer4') {
                for (let c = 0; c < 10; c++) {
                    const nameV = 'toolbarViewer' + (40 + c);
                    state.variables[nameV] = variable.payload.value;
                }
            }
            state.variables[variable.payload.name] = variable.payload.value;
        },
        updateScroll: (state) => {
            state.variables.scrollCount++;
        },
        setAgyleHeaderContext: (state, ctx) => {
            state.agyleHeaderContext = ctx.payload;
        },
        setAgyleHeaderLoading: (state, ctx) => {
            state.agyleHeaderLoading = ctx.payload;
        },
        clearViewersData: (state) => {
            let currentIndex = 1;
            while (true) {
                //
                const variableName = 'toolbarViewer' + currentIndex;
                if (state.variables.hasOwnProperty(variableName)) {
                    delete state.variables[variableName];
                } else
                    break;
                currentIndex++;
            }

            delete state.variables.toolbarViewerQuickAction;
        },
        setSnackbar: (state, variable) => {
            if (variable.payload.message) {
                state.snackbar = {
                    type: variable.payload.type,
                    message: variable.payload.message,
                    action: variable.payload.action || [],
                };
            }
        },
        setBlockContext: (state, data) => {
            state.blockContext = data.payload;
        },
        setOpenAlarms: (state, data) => {
            state.openAlarms = data.payload;
        },
        setOpenDischargeTimestampInfoForm: (state, data) => {
            state.openDischargeTimestampInfoForm = data.payload;
        },
        setTempPiw: (state, data) => {
            state.tempPiw = data.payload;
        },
        setSearchOnlyNumbers: (state, data) => {
            state.searchOnlyNumbers = data.payload;
        },
    },
});

export const {
    setGlobalVariable,
    updateScroll,
    clearViewersData,
    setSnackbar,
    setAgyleHeaderContext,
    setAgyleHeaderLoading,
    setBlockContext,
    setOpenAlarms,
    setOpenDischargeTimestampInfoForm,
    setTempPiw,
    setSearchOnlyNumbers,
} = globalsSlice.actions;
export const systemSnackbarOptions = state => state.globals.snackbar;
export const agyleHeaderContext = state => state.globals.agyleHeaderContext;
export const agyleHeaderLoading = state => state.globals.agyleHeaderLoading;
export const agyleBlockContext = state => state.globals.blockContext;
export const agyleOpenAlarms = state => state.globals.openAlarms;
export const agyleOpenDischargeTimestampInfoForm = state => state.globals.openDischargeTimestampInfoForm;
export const agyleTempPiw = state => state.globals.tempPiw;
export const agyleSearchOnlyNumbers = state => state.globals.searchOnlyNumbers;

export const globalVariable = (name) => {
    return state => state.globals.variables[name];
};

export const openSnackbar = (type, message, action) => (dispatch) => {
    dispatch(setSnackbar({type, message, action: action || []}));
};
export const onUpdateScroll = state => state.globals.variables.scrollCount;

export default globalsSlice.reducer;
